import { t } from "@/i18n-js/instance";
import { ASPECT_RATIO } from "@/react/components/constants";
import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { Form } from "@circle-react-uikit/Form";
import { SpaceHeaderTitleDropdownFullScreen } from "../../SpaceHeaderTitleDropdown/SpaceHeaderTitleDropdownFullScreen";
import { MobileSpaceSettingsButton } from "./MobileSpaceSettingsButton";
import { useManageSpaceActionsV3 } from "./useManageSpaceActionsV3";

export const ManageSpaceActionsV3 = () => {
  const {
    space,
    isAdmin,
    isMember,
    shouldRenderNewMobileWebUI,
    onInviteMemberHandler,
    onSubmitCoverImage,
    isCoverImageModalOpen,
    setIsCoverImageModalOpen,
    onMobileSettingsClickHandler,
  } = useManageSpaceActionsV3();

  if (!space || (!isAdmin && !isMember)) {
    return null;
  }

  if (shouldRenderNewMobileWebUI) {
    return <MobileSpaceSettingsButton onClick={onMobileSettingsClickHandler} />;
  }

  return (
    <>
      <Form
        defaultValues={{ ...space }}
        onSubmit={onSubmitCoverImage}
        className="hidden"
      >
        {({ triggerFormSubmit }) => (
          <CoverImageInput
            name="cover_image"
            renderer={() => null}
            onImageAttachSuccess={triggerFormSubmit}
            aspectRatio={ASPECT_RATIO.COVER_V3}
            showAddCoverBtn={false}
            isOpen={isCoverImageModalOpen}
            onClose={() => setIsCoverImageModalOpen(false)}
          />
        )}
      </Form>
      <ThreeDotsDropdownV3
        label={t("space_settings")}
        dataTestId="space-settings-v3"
      >
        <SpaceHeaderTitleDropdownFullScreen
          space={space}
          isAdmin={isAdmin}
          isMember={isMember}
          onAddCoverImage={() => setIsCoverImageModalOpen(true)}
          onInviteMember={onInviteMemberHandler}
        />
      </ThreeDotsDropdownV3>
    </>
  );
};
